import { useEffect, useState } from "react";
import { TableCell } from "@mui/material";

// Components
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import { KOGTableRow } from "@/main/components/shared/boxGrid/styles";
import LoadingComponent from "@/main/components/shared/loading/loadingComponent";
import QuoteProcurementPartInfo from "@/main/components/shared/quoteProcurementPartInfo/quoteProcurementPartInfo";

// Utils
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { EvaluationSupplierPartsResponse } from "@/main/models/response/evaluationSupplierResponse";
import { evaluationCompanyBuyerApi } from "@/main/api";
import { formatCurrency } from "@/main/services/utilsNumber";

// Styles
import * as S from "./styles";

interface IEvaluationSupplierGridParts {
	guidProcurement: string;
	guidSupplier: string | null;
}
let isFirstLoad: boolean = false;
function EvaluationSupplierGridParts({ guidProcurement, guidSupplier }: IEvaluationSupplierGridParts) {
	// States
	const [data, setData] = useState<EvaluationSupplierPartsResponse[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const rowsGroup = ["200px"];
	const rowHeaders = [
		getTranslateByKey("information.partDescription"),
		getTranslateByKey("information.price"),
		getTranslateByKey("information.deadline"),
		getTranslateByKey("information.deliveredDateNew"),
	];

	function fetchDataGrid(isFirsLoadParam: boolean = false) {
		setIsLoading(true);
		evaluationCompanyBuyerApi
			.getPartsToEvaluateSupplier(guidProcurement, guidSupplier)
			.then((response) => {
				if (!isNullUndefined(response.data.result) && response.data.result.length > 0) setData(response.data.result);
			})
			.finally(() => {
				if (isFirsLoadParam) {
					isFirstLoad = false;
				}
				setIsLoading(false);
			});
	}

	// Load for First supplier
	useEffect(() => {
		isFirstLoad = true;
		fetchDataGrid(true);
	}, []);

	// Load for Next ou Ignore supplier
	useEffect(() => {
		if (!isFirstLoad) {
			fetchDataGrid();
		}
	}, [guidSupplier]);

	if (isLoading) {
		return <LoadingComponent />;
	}

	if (!isLoading && (isNullUndefined(data) || data.length === 0)) {
		return <></>;
	}

	return (
		<S.ContainerTextDescription>
			<span>{getTranslateByKey("information.suppliersParts")}:</span>
			<BoxGrid
				rowHeaders={rowHeaders}
				maxHeight={"310px"}
				marginCustom=".5rem 0 0 0"
				widthCustom="100%"
				sizeColumns={rowsGroup}
			>
				{data.map((item: EvaluationSupplierPartsResponse, index: number) => (
					<KOGTableRow key={index} style={{ cursor: "auto" }}>
						<TableCell>
							<S.ContainerPartInfo>
								<QuoteProcurementPartInfo
									isTooltip
									data={item.quoteProcurementPartInfoResponse}
									renderType="column"
									showLineSupplierInfo={{ info: "2lines" }}
									showIconNotes
								/>
							</S.ContainerPartInfo>
						</TableCell>
						<TableCell>
							<S.CustomColumn title={!isNullUndefined(item.price) ? formatCurrency(item.price) : ""}>
								{!isNullUndefined(item.price) ? formatCurrency(item.price) : "-"}
							</S.CustomColumn>
						</TableCell>
						<TableCell>
							<S.CustomColumn title={!isNullUndefined(item.deadline) ? item.deadline : ""}>
								{!isNullUndefined(item.deadline) ? item.deadline : "-"}
							</S.CustomColumn>
						</TableCell>
						<TableCell>
							<S.CustomColumn title={!isNullUndefined(item.deliveredDate) ? item.deliveredDate : ""}>
								{!isNullUndefined(item.deliveredDate) ? item.deliveredDate : "-"}
							</S.CustomColumn>
						</TableCell>
					</KOGTableRow>
				))}
			</BoxGrid>
		</S.ContainerTextDescription>
	);
}

export default EvaluationSupplierGridParts;
